import { render, staticRenderFns } from "./AtestadoTecnico.vue?vue&type=template&id=36906494"
import script from "./AtestadoTecnico.vue?vue&type=script&lang=js"
export * from "./AtestadoTecnico.vue?vue&type=script&lang=js"
import style0 from "./AtestadoTecnico.vue?vue&type=style&index=0&id=36906494&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports